export const extractSubdomain = () => {
  const originalUrl = window.location.href;

  const parsedUrl = new URL(originalUrl);
  const hostParts = parsedUrl.hostname.split('.');
  const subdomain = hostParts.slice(0, -2).join('.');

  return subdomain;
};
